module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/engine.io-parser/~/isarray/index.js
// module id = ../../../../engine.io-parser/node_modules/isarray/index.js
// module chunks = 3